import { useEffect, useRef } from 'react';
import { useLocale } from '@web3fe/infra';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { getFullPath } from '@web3/base-utils';

/**
 * 监听语言切换，重新拉取语言
 */
export const useChangeLocale = () => {
  const { locale } = useLocale();
  const preLocal = useRef('');

  useEffect(() => {
    if (preLocal.current && locale && preLocal.current !== locale) {
      window.location.href = getFullPath(locale);
    }

    preLocal.current = locale;
  }, [locale]);
};
